import { mapSortType } from 'events/search';

import { toFloatInt } from 'helpers/NumberFormats';

const criteriaToRequestContext = ({ filters, sort }) => ({
  filters: Object.keys(filters || {}).map(attribute => ({ attribute, value: filters[attribute] })),
  sort: mapSortType(sort)
});

const productIdentifiers = ({ productId, styleId, colorId }) => ({ productId, styleId, colorId });

/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SearchProductStreamImpression.proto
 * @param {array} products - List of style objects to be transformed into... ProductIdentifiers.proto
 * @param {bool} personalized - true/false if the results were personalized
 * @param {object} criteria - Search criteria of filters, sort, etc.. (which will be transformed into a ... SearchQueryContext.proto
 * @param {string} searchProductStreamType - See SearchProductStreamType.proto
 * @param {string} sourcePage - PageType - see WebsiteEnums.proto
 */
export const evSearchProductStreamImpression = ({ products, sourcePage, criteria, searchProductStreamType, personalized }) => ({
  searchProductStreamImpression: {
    displayedItems: products.map(productIdentifiers),
    personalized,
    requestContext: criteriaToRequestContext(criteria),
    searchProductStreamType,
    sourcePage
  }
});

/**
 * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SearchProductStreamClick.proto
 * @param {object} product - Item which was clicked. See ProductIdentifiers.proto
 * @param {bool} personalized - true/false if the results were personalized
 * @param {object} criteria - Search criteria of filters, sort, etc.. (which will be transformed into a ... SearchQueryContext.proto
 * @param {string} searchProductStreamType - See SearchProductStreamType.proto
 * @param {string} sourcePage - PageType - see WebsiteEnums.proto
 */
export const evSearchProductStreamClick = ({ indexClicked, product, sourcePage, criteria, searchProductStreamType, personalized }) => ({
  searchProductStreamClick: {
    indexClicked: toFloatInt(indexClicked),
    clickedItem: productIdentifiers(product),
    personalized,
    requestContext: criteriaToRequestContext(criteria),
    searchProductStreamType,
    sourcePage
  }
});
